"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var FreeStyle = require('free-style');
exports.FreeStyle = FreeStyle;
/**
 * Tag the element for rendering later.
 */
var STYLE_ATTRIBUTE = 'data-react-free-style';
/**
 * Check whether we can render on the server/browser.
 */
exports.canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
/**
 * Create a class for passing down the style context.
 */
var GlobalStyleContext = (function () {
    function GlobalStyleContext() {
        this.style = create();
        this.prevChangeId = this.style.changeId;
        if (exports.canUseDOM) {
            this.element = document.querySelector("style[" + STYLE_ATTRIBUTE + "]");
            if (!this.element) {
                this.element = document.createElement('style');
                this.element.setAttribute('type', 'text/css');
                this.element.setAttribute(STYLE_ATTRIBUTE, 'true');
                document.head.appendChild(this.element);
            }
        }
    }
    GlobalStyleContext.prototype.changed = function () {
        if (exports.canUseDOM && this.style.changeId !== this.prevChangeId) {
            this.prevChangeId = this.style.changeId;
            this.element.textContent = this.style.getStyles();
        }
    };
    return GlobalStyleContext;
}());
exports.GlobalStyleContext = GlobalStyleContext;
/**
 * The style context object is passed to the child context to allow dynamic styles.
 */
var StyleContext = (function () {
    function StyleContext(global) {
        this.global = global;
        this.style = create();
    }
    StyleContext.prototype.registerStyle = function (styles, displayName) {
        this.global.style.unmerge(this.style);
        var className = this.style.registerStyle(styles, displayName);
        this.global.style.merge(this.style);
        this.global.changed();
        return className;
    };
    StyleContext.prototype.registerKeyframes = function (styles, displayName) {
        this.global.style.unmerge(this.style);
        var keyframes = this.style.registerKeyframes(styles, displayName);
        this.global.style.merge(this.style);
        this.global.changed();
        return keyframes;
    };
    StyleContext.prototype.registerRule = function (rule, styles) {
        this.global.style.unmerge(this.style);
        this.style.registerRule(rule, styles);
        this.global.style.merge(this.style);
        this.global.changed();
    };
    StyleContext.prototype.mount = function () {
        this.global.style.merge(this.style);
        this.global.changed();
    };
    StyleContext.prototype.unmount = function () {
        this.global.style.unmerge(this.style);
        this.global.changed();
    };
    return StyleContext;
}());
exports.StyleContext = StyleContext;
/**
 * Re-export the `free-style` module.
 */
/**
 * Create a global style container.
 */
var global = new GlobalStyleContext();
/**
 * Get the current render styles.
 */
function rewind() {
    if (exports.canUseDOM) {
        throw new Error('You can only call `rewind()` on the server. Call `peek()` to read the current styles.');
    }
    var styles = peek();
    global = new GlobalStyleContext();
    return styles;
}
exports.rewind = rewind;
/**
 * Peek at the current styles without clearing.
 */
function peek() {
    var css = global.style.getStyles();
    return {
        toComponent: function () {
            return React.createElement('style', (_a = {},
                _a[STYLE_ATTRIBUTE] = true,
                _a.dangerouslySetInnerHTML = { __html: css },
                _a
            ));
            var _a;
        },
        toString: function () {
            return "<style " + STYLE_ATTRIBUTE + "=\"true\">" + css + "</style>";
        },
        toCss: function () {
            return css;
        }
    };
}
exports.peek = peek;
/**
 * Wrap a component instead of adding it to the markup manually.
 */
function wrap(Component, style) {
    return function (props, context) {
        return React.createElement(Style, { style: style }, React.createElement(Component, props));
    };
}
exports.wrap = wrap;
/**
 * Create a style component.
 */
var Style = (function (_super) {
    __extends(Style, _super);
    function Style() {
        _super.apply(this, arguments);
        this._freeStyle = new StyleContext(global);
    }
    Style.prototype.getChildContext = function () {
        return {
            freeStyle: this._freeStyle
        };
    };
    Style.prototype.componentWillMount = function () {
        if (this.props.style) {
            this._freeStyle.style.merge(this.props.style);
        }
        this._freeStyle.mount();
    };
    Style.prototype.componentWillUnmount = function () {
        if (this.props.style) {
            this._freeStyle.style.unmerge(this.props.style);
        }
        this._freeStyle.unmount();
    };
    Style.prototype.render = function () {
        return React.Children.only(this.props.children);
    };
    Style.displayName = 'Style';
    Style.propsTypes = {
        style: React.PropTypes.object.isRequired,
        children: React.PropTypes.node.isRequired
    };
    Style.childContextTypes = {
        freeStyle: React.PropTypes.object.isRequired
    };
    return Style;
}(React.Component));
exports.Style = Style;
/**
 * Create a Free Style instance.
 */
function create(hash, debug) {
    return FreeStyle.create(hash, debug);
}
exports.create = create;
//# sourceMappingURL=react-free-style.js.map


//////////////////
// WEBPACK FOOTER
// ../refire-app/~/react-free-style/dist/react-free-style.js
// module id = 140
// module chunks = 0